// ONBOARDING-P3: plain labels the operator's onboarding console shares (the case list and the
// case detail): case status, follow-up kinds and states, timeline events, seating states.

type Tone = "success" | "warning" | "neutral" | "info" | "danger";

export const CASE_STATUS: Record<string, { label: string; variant: Tone }> = {
  link_sent: { label: "Link sent", variant: "neutral" },
  in_progress: { label: "Intake in progress", variant: "info" },
  intake_complete: { label: "Intake complete", variant: "success" },
  live: { label: "Live", variant: "success" },
  cancelled: { label: "Cancelled", variant: "neutral" },
};

export const FOLLOWUP_KIND: Record<string, string> = {
  reminder: "Friendly reminder",
  missing_list: "What's still missing",
  call_offer: "Call offer",
  operator_alert: "Alert to you",
};

export const FOLLOWUP_STATUS: Record<string, { label: string; variant: Tone }> = {
  scheduled: { label: "Scheduled", variant: "neutral" },
  sent: { label: "Sent", variant: "success" },
  would_send: { label: "Held (no mailer)", variant: "warning" },
  failed: { label: "Failed", variant: "danger" },
  skipped: { label: "Skipped", variant: "neutral" },
};

export const TIMELINE: Record<string, string> = {
  case_opened: "Onboarding opened",
  link_sent: "Onboarding link mailed to the owner",
  link_would_send: "Onboarding link held: send it to the owner",
  link_failed: "Onboarding link could not be mailed",
  intake_saved: "Owner saved an intake step",
  intake_completed: "Owner completed the intake",
  followup_sent: "Follow-up sent",
  followup_would_send: "Follow-up held (no mailer)",
  followup_failed: "Follow-up could not be sent",
  followup_skipped: "Follow-up skipped",
  operator_alerted: "You were alerted: call the owner",
  proposal_drafted: "Setup proposal drafted",
  proposal_draft_failed: "Setup proposal draft failed",
  proposal_edited: "Setup proposal edited",
  proposal_sent: "Setup proposal sent to the client",
  seat_decided: "Owner answered on a seat",
  assistant_assigned: "Setup assistant assigned",
  assistant_revoked: "Setup assistant's access ended",
  intake_moved: "Intake answers moved to the owner's seat",
  case_closed: "Onboarding closed",
  proposal_presented: "Proposal presented in chat",
  call_offered: "Call offered in chat",
  proposal_cost_booked: "Proposal drafting cost booked",
  seating_planned: "Seating planned",
  seat_deployed: "Seat deployed",
  seat_ticketed: "Template ticket opened for a seat",
  seat_refused: "Seat refused",
  seat_blocked: "Seat blocked",
  seat_failed: "Seat step failed",
  seat_progressed: "Seat moved to its next step",
  owner_access_verified: "Owner signed up (evidence)",
  seat_ready: "Seat ready (evidence)",
  spec_applied: "Agent spec applied (evidence)",
  connection_verified: "Connection verified (evidence)",
  connection_failed: "Connection check failed",
  intake_readable: "Intake readable by the digital employees (evidence)",
  first_task_delivered: "First task delivered (evidence)",
  ready: "Ready for handover",
  handover: "Handed over: onboarding ended",
};

export const SEATING_STATUS: Record<string, { label: string; variant: Tone }> = {
  pending: { label: "Pending", variant: "neutral" },
  deploying: { label: "Deploying", variant: "info" },
  deployed: { label: "Deployed", variant: "success" },
  ready: { label: "Ready", variant: "success" },
  ticket: { label: "Template ticket", variant: "info" },
  refused: { label: "Refused", variant: "warning" },
  blocked: { label: "Blocked", variant: "warning" },
  failed: { label: "Failed", variant: "danger" },
};

export const DECISION: Record<string, { label: string; variant: Tone }> = {
  approve: { label: "Approved", variant: "success" },
  change: { label: "Change asked", variant: "warning" },
  not_now: { label: "Not now", variant: "neutral" },
};

export const day = (iso: string) => new Date(iso).toLocaleDateString();
export const when = (iso: string) => new Date(iso).toLocaleString();
